// angular imports
import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
// importing the superclass
import {Module} from './../module.component';
// services imports
import {MaterialListService} from './material-list.service';
// import { BomService } from '../bom-explosion/bom-explosion.service';
import {Status} from './../../service/status.service';
// model imports
import {ModalMaterialDocComponent} from '../MODAL-material-doc/modal-material-doc.component';
import {ModalBomExplosionComponent} from '../MODAL-bom-explosion/modal-bom-explosion.component';
import {PlswaitComponent} from './../MODAL-plswait/plswait.component';

// component definition
@Component({
  selector: 'app-material-list', // the tag used for the instance of the module
  templateUrl: './material-list.component.html', // the HTML file of the module
  providers: // injection of the components
    [
      MaterialListService
      // BomService
    ]

})
export class MaterialListComponent extends Module {

  // IF EMBED IN BOM EXPLOSION
  @Output() materialSelectedEvent = new EventEmitter<string>();
  @Input() private bomMode = false;
  @ViewChild('PlswaitComponent') PlswaitComponent: PlswaitComponent;

  // variable declaration
  private supplier_code = '';
  private material_code = '';
  selectedMaterial = undefined;

  fromIFSR = false;

  // constructor method
  constructor(private materialListService: MaterialListService,
              private status: Status) {

    super();

    this.setBindExposer(status.getExposer());

    this.setFormEnable(this.getCustomizingService().getBoolean('MATERIAL.LIST.FORM.ENABLE', false));
    this.setAutoSearchEnable(this.getCustomizingService().getBoolean('MATERIAL.LIST.AUTOSEARCH.ENABLE', false));

    this.requestModelSetUp();

    // check for the IFRS Lot triggers
    if (this.getIFRS().getLotFunctions().FLAG_getMaterial === true) {
      this.fromIFSR = true;
      this.supplier_code = this.getIFRS().getLotFunctions().getMaterial_supplier_code;
      this.material_code = this.getIFRS().getLotFunctions().getMaterial_material_code;
      this.getIFRS().setBackZone('lot');
      // search
      this.getIFRS().clearAllFunctionsData();
    } else if (this.getIFRS().getHomeFunctions().FLAG_getMaterial === true) {
      this.fromIFSR = true;
      this.material_code = this.getIFRS().getHomeFunctions().getMaterial_material_code;
      this.getIFRS().setBackZone('home');
      // search
      this.getIFRS().clearAllFunctionsData();
    }

    this.searchMaterials();
  }

  // check for back button
  isFromIFRS() {
    return this.fromIFSR;
  }

  // come back to delivery in previous state
  backTo() {
    this.getIFRS().clearAllFunctionsData();
    this.getIFRS().comeBack();
  }

  // set up the request model
  requestModelSetUp() {
    this.getModelsManager().material_list_request.supplier_code = this.getAccountService().supplierProperties.supplier_code;
    this.getModelsManager().material_list_request.company_code = this.getAccountService().getUserCompany().code;
    this.getModelsManager().material_list_request.language = this.getLocale().getPreferredLanguage();
    this.getModelsManager().material_list_request.material_code = '';
  }

  // returns the request model
  getRequestModel() {
    return this.getModelsManager().material_list_request;
  }

  getMaterial_code() {
    return this.material_code;
  }

  setMaterial_code(target) {
    this.material_code = target.value;
    this.getModelsManager().material_list_request.material_code = this.material_code;
  }

  // reset the input params
  clearFormValues() {
    this.material_code = '';
    this.supplier_code = '';
    this.getModelsManager().material_list_request.material_code = '';
    this.getModelsManager().material_list_request.supplier_code = '';
    this.requestModelSetUp();
  }

  // launches the search service
  searchMaterials() {
    this.getModelsManager().material_list_request.language = this.getLocale().getPreferredLanguage();
    if (this.material_code !== '') {
      this.getModelsManager().material_list_request.material_code = this.material_code;
    }
    if (this.supplier_code !== '') {
      this.getModelsManager().material_list_request.supplier_code = this.supplier_code;
    }
    this.materialListService.searchMaterials();
    this.showSearchParameters = false;
  }

  // returns if the server is searching or not
  isServiceSearching() {
    return this.materialListService.isSearching();
  }

  // returns the status of the server query
  isResultEmpty() {
    return this.materialListService.getMaterials().length === 0;
  }

  // returns the response model
  getMaterials() {
    return this.getOrderedList(this.materialListService.getMaterials(), this.sortType, this.sortReverse);
  }

  // shows the modal of the material's documents
  showDocs(modal: ModalMaterialDocComponent, materialCode, materialDescription) {
    modal.setDocs(materialCode,
      materialDescription,
      this.getAccountService().getUserCompany().code,
      this.getLocale().getPreferredLanguage());
    modal.show();
  }

  // download the material report
  downloadSchedaTecnica(divisionCode, materialCode) {
    this.materialListService.downloadSchedaTecnica(divisionCode,
      materialCode,
      this.getLocale().getPreferredLanguage(),
      this.getAccountService().supplierProperties.supplier_code,
      '',
      this.PlswaitComponent
    );
  }
  // Download scalar report in pdf format
  downloadScalareReport(divisionCode, materialCode) {
    this.materialListService.downloadScalareReport(divisionCode,
      materialCode,
      this.getLocale().getPreferredLanguage(),
      this.getAccountService().supplierProperties.supplier_code,
      this.getAccountService().getUserCompany().code,
      this.PlswaitComponent
    );
  }

  // Download scalar report in excel format
  downloadExcelScalareReport(divisionCode, materialCode) {
    this.materialListService.downloadScalareExcelReport(divisionCode,
      materialCode,
      this.getLocale().getPreferredLanguage(),
      this.getAccountService().supplierProperties.supplier_code,
      this.getAccountService().getUserCompany().code,
      this.PlswaitComponent
    );
  }

  downloadArchivio(divisionCode, materialCode) {
    ///material/download?division_code=&material_code=&language=&supplier_code=&company_code=
    this.materialListService.downloadArchivio(divisionCode,
      materialCode,
      this.getLocale().getPreferredLanguage(),
      this.getAccountService().supplierProperties.supplier_code,
      this.getAccountService().getUserCompany().code,
      this.PlswaitComponent
      );
  }

  showBomExplosion(modal: ModalBomExplosionComponent, material) {
    modal.init(material);
    modal.show();
    /*
    this.selectedMaterial = material;
    this.bomModelSetup();
    //this.bomService.getBomExplosion();
    this.materialListService.getBomExplosion();
    */
  }

  getElementSpan(element) {
    const value = element.level * 20;
    return value + 'px';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/material-list/material-list.component.ts